<template>
  <div class="temporaryPassword boxs">
    <!-- ---------------- 设置临时密码-开始 ---------------- -->
    <div class="setPsd" v-if="isSetPsd">
      <el-input
              v-model="setPassword"
              placeholder="请设置临时密码"
              maxlength="8"
              clearable
              class="psdInput"
              type="password"
              show-password
      >
      </el-input>

      <button
              class="butStyle greenBtn"
              @click="setTemporaryPassword"
      >
        请设置一个密码
      </button>

      <button
              class="butStyle cancelBtn"
              @click="goBackCashOut"
      >
        取消
      </button>
    </div>

    <!-- ---------------- 设置临时密码-结束 ---------------- -->


    <!-- ---------------- 输入临时密码-开始 ---------------- -->
    <div class="inputPsd" v-else>
      <img src='@/assets/images/busy/Finance/FinancialAudit/CashOutAudit/lock.png' alt="" class="lockImg">
      <p class="firstP">
        若忘记解锁密码
        <span style="cursor: pointer" href="javascript:;" @click="logOut">退出系统</span>
        重新
      </p>
      <p class="secondP">登录即可</p>
      <el-input
              v-model="password"
              placeholder="请输入临时密码"
              maxlength="8"
              clearable
              class="psdInput"
              type="password"
              show-password
      >
      </el-input>

      <button
              class="butStyle greenBtn"
              @click="unlock"
      >
        输入密码后点我开锁
      </button>
    </div>

    <!-- ---------------- 输入临时密码-结束 ---------------- -->

  </div>
</template>
<script>

  import {IsIntegerAndEnglishCharacter} from '@/utils/validator.js'
  import {logout} from '@/api/common.js'

  export default {
    name: "TemporaryPassword",
    data() {
      return {
        isSetPsd: true, // 是否显示设置密码
        setPassword: null,
        password: null,
      }
    },
    components: {},
    methods: {
      // ---------------- 设置临时密码-开始 --------------------------------
      // 设置一个密码
      setTemporaryPassword() {
        if (!this.setPassword) {
          this.$message.error('请设置临时密码！')
          return
        }
        // if (!IsIntegerAndEnglishCharacter(this.setPassword)) {
        //     this.$message.error('密码只能包含数字和英文字母')
        //     return;
        // }
        localStorage.setItem('TemporaryPassword', this.setPassword)
        this.isSetPsd = false

      },
      // 返回"提现审核"页
      goBackCashOut() {
        this.$router.push({path: '/busy/finance/cashOutAudit'})
      },
      // ---------------- 设置临时密码-结束 --------------------------------


      // ---------------- 输入临时密码-开始 --------------------------------
      // 开锁
      unlock() {
        if (!this.password) {
          this.$message.error('请输入临时密码！')
          return
        }
        // 获取解锁密码（设置的临时密码）
        const unlockPassword = localStorage.getItem('TemporaryPassword')
        if (this.password != unlockPassword) {
          this.$message.error('您输入的密码不正确，请重新输入！')
          return
        }
        localStorage.removeItem('TemporaryPassword')
        this.$router.push({path: '/busy/finance/cashOutAudit'})
        // this.isSetPsd = true
      },

      // 退出系统
      async logOut() {
        // 先请求登出接口
        // 再退出登录
        try {
          await logout()
          localStorage.removeItem('TemporaryPassword')
          if (process.env.NODE_ENV == 'production' || process.env.NODE_ENV == 'beta') {
            parent.window.location.href = process.env.VUE_APP_SECRET_BASE_API + '!ESale/Mall/UI/~view/login'
          }

        } catch (e) {
          console.log(e)
        }
      }

      // ---------------- 输入临时密码-结束 --------------------------------

    },
    created() {
      const unlockPassword = localStorage.getItem('TemporaryPassword')
      if (unlockPassword) {
        // 进入页面检查是否含有临时密码，有的话显示“输入临时密码”
        this.isSetPsd = false
      } else {
        // 没有的话显示“设置临时密码”
        this.isSetPsd = true
      }
    }

  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

  .temporaryPassword {
    width: 100%;
    height: 100%;
    // padding: 274px 0 0;
    // display: flex;
    // flex-flow: column nowrap;
    // align-items: center;
  }

  // 设置临时密码
  .temporaryPassword .setPsd {
    padding: 274px 0 0;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
  }

  // 输入临时密码
  .temporaryPassword .inputPsd {
    padding: 148px 0 0;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
  }

  // 输入框宽度
  .temporaryPassword .psdInput {
    width: 220px;
  }

  // 绿色按钮
  .temporaryPassword .greenBtn {
    margin-top: 18px;
    width: 220px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-radius: 4px;
    background: #2DBAA5;
    color: #FFFFFF;
    &:hover {
      background-color: rgb(134, 189, 180)
    }
  }

  // 取消按钮
  .temporaryPassword .cancelBtn {
    margin-top: 18px;
    width: 220px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-radius: 4px;
    background: none;
    color: #7F7F7F;
    border: 1px solid #F8F8F8;
    &:hover {
      border: 1px solid #d1d0d0;
    }
  }

  // 图片-锁头
  .temporaryPassword .lockImg {
    width: 58px;
    height: 58px;
    // position: absolute;
    // top: 148px;
  }

  // 文字
  .temporaryPassword p {
    height: 16px;
    line-height: 16px;
    color: #7F7F7F;
    font-size: 12px;

  }

  .temporaryPassword p.firstP {
    // position: absolute;
    // top: 210px;
    margin-top: 4px;
  }

  .temporaryPassword p.secondP {
    // position: absolute;
    // top: 226px;
    margin-top: 0px;
    margin-bottom: 32px;
  }

  .temporaryPassword span {
    color: #FA6241;
  }

</style>
